import React from 'react';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';

const InvoiceFilters = ({ filters, onFilterChange, onReset, onExport }) => {
  const statusOptions = [
    { value: 'all', label: 'Tous les statuts' },
    { value: 'pending', label: 'En attente' },
    { value: 'paid', label: 'Payé' },
    { value: 'overdue', label: 'En retard' },
    { value: 'cancelled', label: 'Annulé' }
  ];

  const periodOptions = [
    { value: 'all', label: 'Toutes les périodes' },
    { value: 'today', label: "Aujourd\'hui" },
    { value: 'week', label: 'Cette semaine' },
    { value: 'month', label: 'Ce mois' },
    { value: 'quarter', label: 'Ce trimestre' },
    { value: 'year', label: 'Cette année' },
    { value: 'custom', label: 'Période personnalisée' }
  ];

  return (
    <div className="bg-card rounded-lg p-6 border border-border shadow-card mb-6">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-4">
        <Input
          type="search"
          placeholder="Rechercher par conception, patient..."
          value={filters?.search}
          onChange={(e) => onFilterChange('search', e?.target?.value)}
          className="w-full"
        />

        <Select
          placeholder="Statut"
          options={statusOptions}
          value={filters?.status}
          onChange={(value) => onFilterChange('status', value)}
        />

        <Select
          placeholder="Période"
          options={periodOptions}
          value={filters?.period}
          onChange={(value) => onFilterChange('period', value)}
        />

        <div className="flex gap-2">
          <Input
            type="number"
            placeholder="Montant min"
            value={filters?.minAmount}
            onChange={(e) => onFilterChange('minAmount', e?.target?.value)}
            className="w-full"
          />
          <Input
            type="number"
            placeholder="Montant max"
            value={filters?.maxAmount}
            onChange={(e) => onFilterChange('maxAmount', e?.target?.value)}
            className="w-full"
          />
        </div>
      </div>
      {filters?.period === 'custom' && (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
          <Input
            type="date"
            label="Date de début"
            value={filters?.startDate}
            onChange={(e) => onFilterChange('startDate', e?.target?.value)}
          />
          <Input
            type="date"
            label="Date de fin"
            value={filters?.endDate}
            onChange={(e) => onFilterChange('endDate', e?.target?.value)}
          />
        </div>
      )}
      <div className="flex flex-wrap gap-3">
        <Button variant="outline" onClick={onReset} iconName="RotateCcw" iconPosition="left">
          Réinitialiser
        </Button>
        <Button variant="default" onClick={onExport} iconName="Download" iconPosition="left">
          Exporter
        </Button>
      </div>
    </div>
  );
};

export default InvoiceFilters;